// Un lote se lanza UNA vez — ADR-2026-09-13-el-lote-se-lanzaba-dos-veces.
//
// `LoteImagenesCard.generar()` tenía su guard (`disparadoRef`) DESPUÉS de un `await` (la
// consulta de saldo): un segundo `generar()` en esos ~100 ms pasaba el chequeo y acuñaba
// sus propios `execution_id` — el mismo lote de tres salía dos veces, seis imágenes
// cobradas. En desarrollo pasaba SIEMPRE (StrictMode dispara el efecto de auto-generar
// dos veces al montar); en producción, cuando coincidían el auto-disparo y un click, o
// un remount en esa ventana.
//
// El guard de la card ahora se pone antes del primer `await`. Éste es el segundo
// cerrojo, por id de card y a nivel de MÓDULO: cubre dos INSTANCIAS de la misma card
// (un remount en la ventana), que un ref por instancia no ve. Puro, para testearlo.
//
// Desde ADR-2026-09-14-generar-una-sola-vez-por-click es el cerrojo de TODOS los botones
// que generan y cobran: las tres cards del chat (por id de card), "Regenerar imagen" de
// la verificación (`regenerar:<imagen>`) y el carrusel del inline (`carrusel:<imagen>`).
// Todos tenían el mismo agujero que tuvo el lote: un `useState` de "generando" que dos
// clicks en el mismo tick ven en false. La clave es un string libre: cada botón usa la
// suya y ninguno pisa a otro.

const enLanzamiento = new Set<string>();

/** Reserva el lanzamiento de esa card. `false` = ya hay uno en curso: no lances. */
export function reservarLanzamiento(cardId: string): boolean {
  if (enLanzamiento.has(cardId)) return false;
  enLanzamiento.add(cardId);
  return true;
}

/** Libera la reserva: el lanzamiento terminó (bien o mal) o no llegó a salir. */
export function liberarLanzamiento(cardId: string): void {
  enLanzamiento.delete(cardId);
}

/** Para los tests. */
export const hayLanzamientoEnCurso = (cardId: string): boolean => enLanzamiento.has(cardId);
